import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

export const OreVeicolo = (props) => (
  <Card
    sx={{ height: '100%' }}
    {...props}
  >
    <CardContent>
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
          <Typography
            color="textSecondary"
            gutterBottom
            variant="overline"
          >
            Totale ore veicolo
          </Typography>
          <Typography
            color="textPrimary"
            variant="h4"
          >
            {props.oreVeicolo?
            props.oreVeicolo.toFixed(2)
          :
          ""}
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: '#c51162',
              height: 56,
              width: 56
            }}
          >
            <AccessTimeIcon />
          </Avatar>
        </Grid>
      </Grid>
      <Box
        sx={{
          pt: 2,
          display: 'flex',
          alignItems: 'center'
        }}
      >
      </Box>
    </CardContent>
  </Card>
);
